import React from 'react';
import {Grid,Image} from 'semantic-ui-react';
import EmptyStateStar from '../../assets/quick/star.svg';

export class CheckoutsEmptyState extends React.Component {
	render() {
		return (
			<Grid
				textAlign="center"
				style={{marginBottom: '60px', marginTop: '30px'}}
			>
				<Grid.Column style={{maxWidth: 450}}>
					<Grid.Row>
						<Grid.Column>
							<Image src={EmptyStateStar} className="center" />
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column>
							<p className="center" style={{marginBottom: '0px', fontSize: '16px'}}>
								You do not have any abandoned checkouts yet.
							</p>
						</Grid.Column>
					</Grid.Row>
				</Grid.Column>
			</Grid>
		);
	}
}

export default CheckoutsEmptyState;



// WEBPACK FOOTER //
// ./src/components/empty-states/checkouts_empty_state.jsx